import React, { useState } from "react";
import axios from "axios";
import { USER_URL } from "../../constant/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaCloudUploadAlt } from "react-icons/fa";

function AdminCreateCategory() {
  const [categoryName, setCategoryName] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Form Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryName || !image) {
      toast.warn("Please fill in all fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", categoryName);  // Match backend field name
    formData.append("image", image);

    try {
      setIsSubmitting(true);
      
      const response = await USER_URL.post(
        `/categories/admin/`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Category added successfully!");
      console.log("Response:", response.data);
      
      // Clear form
      setCategoryName("");
      setImage(null);
      setPreview(null);
    } catch (error) {
      console.error("Error adding category:", error);
      toast.error(error.response?.data?.message || "Failed to add category.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-3">
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="border-2 rounded-lg shadow-lg bg-white p-16 pt-8 w-full">
        <h2 className="text-green-600 text-3xl font-bold text-center mb-8 p-5">Create Category</h2>

        <form onSubmit={handleSubmit} className="flex items-start justify-between">
          {/* Image Upload Section */}
          <div className="flex flex-col w-1/2">
            <label className="text-md font-medium mb-2">Category Image</label>
            <div className="w-44 h-44 border flex items-center justify-center rounded-lg overflow-hidden bg-gray-100">
              {preview ? (
                <img src={preview} alt="Preview" className="w-full h-full object-cover" />
              ) : (
                <span className="text-center text-gray-500 text-sm">No image selected</span>
              )}
            </div>
            <label className="flex items-center cursor-pointer text-white bg-blue-500 px-4 py-2 mt-3 w-44 rounded-md hover:bg-blue-600 text-sm">
                         <FaCloudUploadAlt className="mr-2 text-lg" />
                        Upload Image
                         <input 
                           type="file" 
                           onChange={handleImageChange} 
                           className="hidden" 
                           accept="image/*" 
                         />
                       </label>
          </div>

          {/* Category Name Input */}
          <div className="flex flex-col w-1/2">
            <label className="text-md font-medium mb-2">Category Name</label>
            <input
              type="text"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Enter Category name"
              className="border mb-5 px-3 py-2 rounded focus:outline-none focus:ring focus:ring-green-200"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full bg-green-600 text-white py-2 rounded mt-4 transition ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-green-700"
              }`}
            >
              {isSubmitting ? "Submitting..." : "Create Category"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminCreateCategory;

